// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Income/WizardAddIncome.css */

.modal-content.wizard-income {
  min-width: 600px;
  max-width: 720px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.wizard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 2px solid #3498DB;
  background: #F8FAFC;
}

.wizard-header h3 {
  margin: 0;
  color: #2C3E50;
  font-size: 18px;
}

.wizard-header .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #7F8C8D;
  padding: 0;
  line-height: 1;
}

.wizard-header .close-btn:hover {
  color: #E74C3C;
}

.wizard-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px 24px;
}

.wizard-section {
  margin-bottom: 24px;
}

.wizard-section h4 {
  font-size: 14px;
  color: #7F8C8D;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #ECF0F1;
}

/* Type cards */
.type-cards-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.type-category {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.category-label {
  font-size: 11px;
  color: #95A5A6;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.type-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.type-card {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(33.333% - 6px);
  min-width: 140px;
  padding: 12px;
  border: 2px solid #ECF0F1;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: white;
}

.type-card:hover {
  border-color: var(--card-color, #3498DB);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.type-card.selected {
  border-color: var(--card-color, #3498DB);
  background: linear-gradient(180deg, white 0%, rgba(var(--card-color), 0.05) 100%);
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
}

.type-icon {
  font-size: 24px;
  margin-bottom: 6px;
}

.type-label {
  font-weight: 600;
  color: #2C3E50;
  font-size: 13px;
}

.type-description {
  font-size: 11px;
  color: #95A5A6;
  margin-top: 4px;
}

/* Period fields */
.period-fields {
  display: flex;
  gap: 16px;
}

.period-fields .form-group {
  flex: 1 1;
}

/* Form groups */
.form-group {
  margin-bottom: 12px;
}

.form-group label {
  display: block;
  font-size: 13px;
  color: #34495E;
  margin-bottom: 6px;
  font-weight: 500;
}

.form-group input[type="text"],
.form-group input[type="number"],
.form-group input[type="date"],
.form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #BDC3C7;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #3498DB;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}

.form-group .help-text {
  display: block;
  font-size: 11px;
  color: #95A5A6;
  margin-top: 4px;
}

.form-group .help-text.warning {
  color: #E67E22;
}

/* Checkbox label */
.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #34495E;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.vary-checkbox {
  margin-bottom: 16px;
  padding: 12px;
  background: #F8FAFC;
  border-radius: 6px;
}

/* Specific fields */
.specific-fields {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

/* Single amount section */
.single-amount-section {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.single-amount-section .form-group {
  flex: 1 1;
}

.single-amount-section .calculation-preview {
  flex: 1 1;
}

/* Year tabs */
.yearly-amounts-section {
  background: #F8FAFC;
  border-radius: 8px;
  padding: 16px;
}

.year-tabs {
  display: flex;
  gap: 4px;
  border-bottom: 2px solid #ECF0F1;
  margin-bottom: 16px;
}

.year-tab {
  position: relative;
  padding: 10px 20px;
  border: none;
  background: none;
  font-size: 14px;
  color: #7F8C8D;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 6px 6px 0 0;
}

.year-tab:hover {
  color: #3498DB;
  background: rgba(52, 152, 219, 0.1);
}

.year-tab.active {
  color: #3498DB;
  background: white;
  font-weight: 600;
  border: 2px solid #ECF0F1;
  border-bottom-color: white;
  margin-bottom: -2px;
}

.year-indicator {
  position: absolute;
  top: 6px;
  right: 6px;
  font-size: 8px;
  color: #27AE60;
}

.year-content {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  padding: 16px;
  background: white;
  border-radius: 8px;
  margin-bottom: 16px;
}

.year-content .form-group {
  flex: 1 1;
}

.year-content .calculation-preview {
  flex: 1 1;
}

/* Calculation preview */
.calculation-preview {
  background: #E8F6FF;
  padding: 12px 16px;
  border-radius: 8px;
}

.preview-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #34495E;
  padding: 4px 0;
}

.preview-row.result {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #BDE0F5;
}

.preview-row .taxable {
  font-weight: 700;
  color: #27AE60;
  font-size: 16px;
}

/* Years summary */
.years-summary {
  background: white;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #ECF0F1;
}

.years-summary h5 {
  margin: 0 0 12px 0;
  font-size: 12px;
  color: #7F8C8D;
  text-transform: uppercase;
}

.summary-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.summary-row {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
}

.summary-row .year {
  font-weight: 600;
  color: #2C3E50;
  min-width: 50px;
}

.summary-row .amount {
  color: #7F8C8D;
  min-width: 100px;
}

.summary-row .taxable {
  color: #27AE60;
  font-weight: 500;
}

.summary-grid .no-data {
  color: #BDC3C7;
  font-style: italic;
  font-size: 12px;
}

/* Footer */
.wizard-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #ECF0F1;
  background: #F8FAFC;
}

.wizard-footer .cancel-btn {
  padding: 10px 20px;
  border: 1px solid #BDC3C7;
  background: white;
  color: #7F8C8D;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-footer .cancel-btn:hover {
  border-color: #95A5A6;
  color: #34495E;
}

.wizard-footer .save-btn {
  padding: 10px 24px;
  border: none;
  background: #3498DB;
  color: white;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-footer .save-btn:hover:not(:disabled) {
  background: #2980B9;
}

.wizard-footer .save-btn:disabled {
  background: #BDC3C7;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 700px) {
  .modal-content.wizard-income {
    min-width: 100%;
    max-width: 100%;
    margin: 0;
    border-radius: 0;
    max-height: 100vh;
  }

  .type-card {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 4px);
    min-width: 120px;
  }

  .specific-fields {
    grid-template-columns: 1fr;
  }

  .period-fields {
    flex-direction: column;
  }

  .single-amount-section,
  .year-content {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Income/WizardAddIncome.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,YAA6B;EAA7B,cAA6B;EAA7B,+BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,iFAAiF;EACjF,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;IACf,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;EACxB;AACF","sourcesContent":["/* src/components/Income/WizardAddIncome.css */\n\n.modal-content.wizard-income {\n  min-width: 600px;\n  max-width: 720px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n}\n\n.wizard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  border-bottom: 2px solid #3498DB;\n  background: #F8FAFC;\n}\n\n.wizard-header h3 {\n  margin: 0;\n  color: #2C3E50;\n  font-size: 18px;\n}\n\n.wizard-header .close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #7F8C8D;\n  padding: 0;\n  line-height: 1;\n}\n\n.wizard-header .close-btn:hover {\n  color: #E74C3C;\n}\n\n.wizard-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 24px;\n}\n\n.wizard-section {\n  margin-bottom: 24px;\n}\n\n.wizard-section h4 {\n  font-size: 14px;\n  color: #7F8C8D;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0 0 12px 0;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #ECF0F1;\n}\n\n/* Type cards */\n.type-cards-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.type-category {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.category-label {\n  font-size: 11px;\n  color: #95A5A6;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.type-cards {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.type-card {\n  flex: 0 0 calc(33.333% - 6px);\n  min-width: 140px;\n  padding: 12px;\n  border: 2px solid #ECF0F1;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  background: white;\n}\n\n.type-card:hover {\n  border-color: var(--card-color, #3498DB);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.type-card.selected {\n  border-color: var(--card-color, #3498DB);\n  background: linear-gradient(180deg, white 0%, rgba(var(--card-color), 0.05) 100%);\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);\n}\n\n.type-icon {\n  font-size: 24px;\n  margin-bottom: 6px;\n}\n\n.type-label {\n  font-weight: 600;\n  color: #2C3E50;\n  font-size: 13px;\n}\n\n.type-description {\n  font-size: 11px;\n  color: #95A5A6;\n  margin-top: 4px;\n}\n\n/* Period fields */\n.period-fields {\n  display: flex;\n  gap: 16px;\n}\n\n.period-fields .form-group {\n  flex: 1;\n}\n\n/* Form groups */\n.form-group {\n  margin-bottom: 12px;\n}\n\n.form-group label {\n  display: block;\n  font-size: 13px;\n  color: #34495E;\n  margin-bottom: 6px;\n  font-weight: 500;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"number\"],\n.form-group input[type=\"date\"],\n.form-group select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #BDC3C7;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #3498DB;\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\n}\n\n.form-group .help-text {\n  display: block;\n  font-size: 11px;\n  color: #95A5A6;\n  margin-top: 4px;\n}\n\n.form-group .help-text.warning {\n  color: #E67E22;\n}\n\n/* Checkbox label */\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #34495E;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.vary-checkbox {\n  margin-bottom: 16px;\n  padding: 12px;\n  background: #F8FAFC;\n  border-radius: 6px;\n}\n\n/* Specific fields */\n.specific-fields {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n/* Single amount section */\n.single-amount-section {\n  display: flex;\n  gap: 24px;\n  align-items: flex-start;\n}\n\n.single-amount-section .form-group {\n  flex: 1;\n}\n\n.single-amount-section .calculation-preview {\n  flex: 1;\n}\n\n/* Year tabs */\n.yearly-amounts-section {\n  background: #F8FAFC;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.year-tabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 2px solid #ECF0F1;\n  margin-bottom: 16px;\n}\n\n.year-tab {\n  position: relative;\n  padding: 10px 20px;\n  border: none;\n  background: none;\n  font-size: 14px;\n  color: #7F8C8D;\n  cursor: pointer;\n  transition: all 0.2s;\n  border-radius: 6px 6px 0 0;\n}\n\n.year-tab:hover {\n  color: #3498DB;\n  background: rgba(52, 152, 219, 0.1);\n}\n\n.year-tab.active {\n  color: #3498DB;\n  background: white;\n  font-weight: 600;\n  border: 2px solid #ECF0F1;\n  border-bottom-color: white;\n  margin-bottom: -2px;\n}\n\n.year-indicator {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  font-size: 8px;\n  color: #27AE60;\n}\n\n.year-content {\n  display: flex;\n  gap: 24px;\n  align-items: flex-start;\n  padding: 16px;\n  background: white;\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n.year-content .form-group {\n  flex: 1;\n}\n\n.year-content .calculation-preview {\n  flex: 1;\n}\n\n/* Calculation preview */\n.calculation-preview {\n  background: #E8F6FF;\n  padding: 12px 16px;\n  border-radius: 8px;\n}\n\n.preview-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n  color: #34495E;\n  padding: 4px 0;\n}\n\n.preview-row.result {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #BDE0F5;\n}\n\n.preview-row .taxable {\n  font-weight: 700;\n  color: #27AE60;\n  font-size: 16px;\n}\n\n/* Years summary */\n.years-summary {\n  background: white;\n  padding: 12px 16px;\n  border-radius: 8px;\n  border: 1px solid #ECF0F1;\n}\n\n.years-summary h5 {\n  margin: 0 0 12px 0;\n  font-size: 12px;\n  color: #7F8C8D;\n  text-transform: uppercase;\n}\n\n.summary-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.summary-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 13px;\n}\n\n.summary-row .year {\n  font-weight: 600;\n  color: #2C3E50;\n  min-width: 50px;\n}\n\n.summary-row .amount {\n  color: #7F8C8D;\n  min-width: 100px;\n}\n\n.summary-row .taxable {\n  color: #27AE60;\n  font-weight: 500;\n}\n\n.summary-grid .no-data {\n  color: #BDC3C7;\n  font-style: italic;\n  font-size: 12px;\n}\n\n/* Footer */\n.wizard-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid #ECF0F1;\n  background: #F8FAFC;\n}\n\n.wizard-footer .cancel-btn {\n  padding: 10px 20px;\n  border: 1px solid #BDC3C7;\n  background: white;\n  color: #7F8C8D;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-footer .cancel-btn:hover {\n  border-color: #95A5A6;\n  color: #34495E;\n}\n\n.wizard-footer .save-btn {\n  padding: 10px 24px;\n  border: none;\n  background: #3498DB;\n  color: white;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-footer .save-btn:hover:not(:disabled) {\n  background: #2980B9;\n}\n\n.wizard-footer .save-btn:disabled {\n  background: #BDC3C7;\n  cursor: not-allowed;\n}\n\n/* Responsive */\n@media (max-width: 700px) {\n  .modal-content.wizard-income {\n    min-width: 100%;\n    max-width: 100%;\n    margin: 0;\n    border-radius: 0;\n    max-height: 100vh;\n  }\n\n  .type-card {\n    flex: 0 0 calc(50% - 4px);\n    min-width: 120px;\n  }\n\n  .specific-fields {\n    grid-template-columns: 1fr;\n  }\n\n  .period-fields {\n    flex-direction: column;\n  }\n\n  .single-amount-section,\n  .year-content {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
